var colours = [
  ['Grey', 'A9A9A9'],
  ['Burgundy', '800020'],
  ['Kakhi Green', '8A865D'],
  ['White', 'ffffff'],
  ['Dark Grey', '808080'],
  ['Brown', '87624f'],
  ['Charcoal Grey', '36454f'],
  ['Blue', '31456b'],
  ['Black', '000000'],
  ['Yellow', 'f8e2a4'],
  ['Pink', 'f4cfd7'],
  ['Beige', 'e1c699'],
  ['Ivory', 'FFFFF0'],
  ['Green', '94c2ae'],
  ['Navy', '000080'],
  ['Black & Gold', '000000'],
  ['Botella', '34623e'],
  ['Nero', '000000'],
  ['Naturel', 'D3AC7A'],
  ['Natural', 'D3AC7A'],
  ['Skin', 'e3c3a9'],
  ['Teint', 'e0b38c'],
  ['Champagne', 'faf8d2'],
  ['Nude', 'C59C6D'],
  ['Mandorla', 'e1c699'],
  ['Ghiaccio', 'D3D3D3'],
  ['Night Blue', '2e3237'],
  ['Wilted Yellow', 'EEEE9B'],
  ['Nocturnal Blue', '867a8c'],
  ['Cedar Green', '4e5853'],
  ['Iris Grey', 'c0aa9d'],
  ['Steel Blue', '656772'],
  ['Paradise Blue', '6f697f'],
  ['Umber Brown', '4f403a'],
  ['Sand Beige', 'd2b596'],
  ['Cactus Green', '3f4534'],
  ['Crimson Red', 'a43b3c'],
  ['Green and Buttercup Yellow', 'f4b341'],
  ['Celadon Green', 'aea96c'],
  ['Dark Green', '5c5c3a'],
  ['Grape Purple', '8b5f6f'],
  ['Rosebud Pink', 'eacbca'],
  ['Indienne Ochre', 'd79b49'],
  ['Denim Blue', '42567c'],
  ['Ochre Brown', 'c4954c'],
  ['Orange', 'cd663e'],
  ['Aqua Blue', 'bed4cc'],
  ['Buttercup', 'f4b341'],
  ['Ming Green', '77a888'],
  ['Moss', 'a7a672'],
  ['Caramel', '926447'],
  ['Pinky', 'e1b59f'],
  ['Multicolour', '000000'],
  ['Sky Blue', 'c6d1d7'],
  ['Multi', '000000'],
  ['Fluro Yellow', 'eee444'],
  ['Sage Green', 'c5bf9d'],
  ['Blue/Black', '34333a'],
  ['Sage', 'd7d2b7'],
  ['Crimson', 'DC143C'],
  ['Dark', '322f37'],
  ['Zest', 'a7a672'],
  ['Orchid', 'f8a23f'],
  ['Cedar', '788f8c'],
  ['Pumpkin Orange', 'f3692d'],
  ['Sepia Brown', '884636'],
  ['Multicolour Socks', '000000'],
  ['Fume', '4c4b46'],
  ['Griggio', 'a3a1a2'],
  ['Negro', '000000'],
  ['Teka', '9c7146'],
  ['Moreno', 'a47d52'],
  ['Melis', 'bb9f6f'],
  ['Marron', '4e411f'],
  ['Grafito', '4b595c'],
  ['Chocolat', '362a12'],
  ['Dore', 'e4c5b0'],
  ['Azulon', '2345a7'],
  ['Marino', '131f2d'],
  ['Botella', '354e30'],
  ['Te', 'd59045'],
  ['Rouge', 'be0026'],
  ['Granate', '4c0b36'],
  ['Emerald', '018436'],
  ['Antracita', '3d3f3c'],
  ['Amatista', '521a61'],
  ['Violeta', '522465'],
  ['Deep Blue', '1b1c30'],
  ['Graphite', '5b5b5b'],
  ['Marine Dark', '3d3e54'],
  ['Garnet', 'a82b2c'],
  ['Bottle Green', '1d3629'],
  ['Violet', '493b4d'],
  ['Tee', 'b38263'],
  ['Blush', 'f5d8c2'],
  ['Noir', '000000'],
  ['Gris Fonce', '2f3c45'],
  ['Marine', '0d0e40'],
  ['Gazelle', 'c8ad90'],
  ['Tan', 'c69264'],
  ['Gazelle Natural', 'c8ad90'],
  ['Black/gold Seam', 'FFD700'],
  ['Black/silver Seam', 'C0C0C0'],
  ['Red/black Seam', 'b61132'],
  ['Tan/black Seam', 'a0755b'],
  ['Nude/black Seam', 'c69264'],
  ['Black/royal Blue Seam', '35394e'],
  ['Black/red Seam', 'b81838'],
  ['Nude/black Seam Tight', 'c79166'],
  ['Forest Green', '424735'],
  ['Plum', '4c1439'],
  ['Nearly Black', '3b3638'],
  ['Marine', '2b3143'],
  ['Chartreux', '6c6867'],
  ['Stellar', '46647f'],
  ['Aubergine', '702e3b'],
  ['Blue Black', '373b47'],
  ['Blue/black', '373b47'],
  ['Cacao', '483b39'],
  ['Mustard', '9a662c'],
  ['Carmine', '954f59'],
  ['Blush', '76202d'],
  ['Ristretto', '3a2f2e'],
  ['Tango', 'ac0f2e'],
  ['Autumn', 'd39238'],
  ['Cherry', '7c243c'],
  ['Blue Green', '0d98ba'],
  ['Cayenne', '941100'],
  ['Dark Purple', '800080'],
  ['Sunflower', 'FFCC33'],
  ['Terra Cotta', 'e2725b'],
  ['Honey', 'FF9933'],
  ['Tendresse', 'ab8570'],
  ['Bruges', '654f40'],
  ['Coca', '493c3a'],
  ['Navy Blue', '2d2d44'],
  ['Soleil', '986e56'],
  ['Taupe', '3d3435'],
  ['Off White', 'FAF9F6'],
  ['Grigio', '878787'],
  ['Angel', 'ceb2a5'],
  ['Summer', '9b7353'],
  ['Off White Socks', 'FAF9F6'],
  ['Black Socks', '000000'],
  ['Black/white', '000000'],
  ['Gold Lurex', 'FFD700'],
  ['Silver Lurex', 'C0C0C0'],
  ['Coffee', '8A624A'],
  ['Pearl', 'd1cfd7'],
  ['Red', 'b83654'],
  ['Red Orchid', '8b2233'],
  ['Black tights', '000000'],
  ['Black/gold', 'FFD700'],
  ['Black/silver', 'C0C0C0'],
  ['Leopard', 'c4a488'],
  ['Gold', 'FFD700'],
  ['Silver', 'C0C0C0'],
  ['Shiny Green', '4d4f3f'],
  ['Bordeaux', '862834'],
  ['Angle', 'ceb2a5'],
  ['Savane', 'bea385'],
  ['Blue/grey', '3a6188'],
  ['Yellow/grey', 'd59504'],
  ['Grey Socks', '827e7b'],
  ['Black /azure', '007FFF'],
  ['Caresesse', '9b7353'],
  ['Leopard Pattern', 'c4a488'],
  ['Pink/blue', 'd08f96'],
  ['Beige/orange', 'f4c89d'],
  ['Black Childrens Cotton Socks', '000000'],
  ['Navy Childrens Cotton Socks', '000080 '],
  ['Red And White Hearts', '8B0000'],
  ['Fleet', '000080 '],
  ['Snow', 'FFFAFA'],
  ['Pale Pink', 'fadadd'],
  ['Au Natural', 'e3c3a9'],
  ['Brume', '6c565d'],
  ['Bleue Nuit', '20445B'],
  ['Camel', 'c19a6b'],
  ['Gris Polvre', '383e42'],
  ['Nuage', 'E3BC9A'],
  ['Beige Dore', 'EED7C2'],
  ['Poudre', 'E1B3B2'],
  ['Au Naturel', 'e3c3a9'],
  ['Blanc', 'ffffff'],
  ['Cappuccino', 'C5AB9F'],
  ['Gazelle', 'c8ad90'],
  ['Marine Sunlight', '0981D1'],
  ['Nuage Sunlight', 'F1EDE1'],
  ['Anthracite/noir', '404040'],
  ['Coquil', 'F5E2C5'],
  ['Opera', '251b1e'],
  ['Peau Bronze', '986e56'],
  ['Paprika', 'cd3428'],
  ['Gazelle Tan', 'c8ad90'],
  ['Make-Up', 'a6866d'],
  ['Make Up', 'a6866d'],
  ['Black/red Seam', 'd93529'],
  ['Black/black Seam', '000000'],
  ['Teint/black Seam', 'e0b38c'],
  ['Purple', '6c2f79'],
  ['Pink Diamond', 'e44760'],
  ['Blue Diamond', '0698d3'],
  ['Charcoal Leopard', '91948f'],
  ['Morello', '55212e'],
  ['Chocolate Brown', 'd93529'],
  ['Cranberry', 'e94848'],
  ['Puder', 'c39177'],
  ['Deep Grey', '423e48'],
  ['Deep Dawn', '393b4f'],
  ['Deep Burgundy', '61334c'],
  ['Marine', '14152b'],
  ['Graphite', '3c4544'],
  ['Cashmere', 'b17f62'],
  ['Pale Pink', 'f6e4d6'],
  ['Antracite', '313d46'],
  ['Light Grey', 'f4f0ed'],
  ['Pure Desert', 'a4805f'],
  ['Wine', '441520'],
  ['Bark', '403a41'],
  ['Aubergine', '49363d'],
  ['Blue/Grey', '325b74'],
  ['Thistle', 'c1bfcb'],
  ['Sunrise', 'ecb484'],
  ['Mint', '9cfc97'],
  ['Rose Quartz', 'feddd8'],
  ['Light Blue', 'e4ebf4'],
  ['Rust', 'B7410E'],
  ['Anthracite', '383E42 '],
  ['Smokey Jade', 'BACEC1'],
  ['Dawn', 'E49759 '],
  ['Purple/pink', '5b1f33'],
  ['Anthrazitmel', '383E42'],
  ['Blue/grey', '325b74'],
  ['Brownie', '964b00'],
  ['Londra', '2F2224'],
  ['Blu Marine', '1B2459'],
  ['Blumarine', '1B2459'],
  ['Antracite', '4F3F44'],
  ['Mocca', '25120D'],
  ['Fumo', '5D3630'],
  ['Nullita', '6F5848'],
  ['Cappuccino', '7D584D'],
  ['Lyon', '81523C'],
  ['Sunbasque', '805B3F'],
  ['Summer Glow', '8E694E'],
  ['Suede', '9E785D'],
  ['Havana', 'AC7346'],
  ['Hazelnut', 'B28B65'],
  ['Visone', 'C3945D'],
  ['Golden Tint', 'C08E64'],
  ['Honey Kiss', 'CC956B'],
  ['Oyster', 'D5BF9A'],
  ['Honey', 'EBA937'],
  ['Crushed Berry', '37232a'],
  ['Nightshadow Blue', '2c2a36'],
  ['Perla', 'dfd1cf'],
  ['Chocolate Brown', '7B3F00'],
  ['Dark Blue', '00008B'],
  ['Medium Beige', 'ab8570'],
  ['Light Beige', 'bea385'],
  ['Chilli', 'E32227'],
  ['Lavender', 'E6E6FA'],
  ['Mid Blue', '0000cd'],
  ['Emerald', '50C878'],
  ['Black Thigh Protector Lace', '000000'],
  ['Berry', 'AB0B23'],
  ['Navy Blue', '2e3449'],
  ['Mustard', 'bb693c'],
  ['Burgandy', '5d3450'],
  ['Gold / Mustard', 'E1AD01'],
  ['Blue/black', '040720'],
  ['Gold/ Mustard', 'E1AD01'],
  ['Bronze', 'a26c31'],
  ['Cream', 'fffefa'],
  ['Rose Pink', 'f4d7c1'],
  ['Grape Shake', '777e9f '],
  ['Windsor Red', 'AB2330'],
  ['Rainbow', 'f6bfbc'],
  ['Dark Brown', '5C4033'],
  ['Dark Brick', 'BC4A3C'],
  ['Deep Forest', '003314'],
  ['Rose', 'FF007F'],
  ['Rose Dust', '9e5e6f'],
  ['Rose Blush', 'E8C7C8'],
  ['Soft Petrol', '005f6a'],
  ['Grape Wine', '5a2f43'],
  ['Dark Honey', '8b6647'],
  ['Honey', 'FF9933'],
  ['Dark Grey', '404040'],
  ['Cyclamen', 'd38c9b'],
  ['Idro', '69b6a9'],
  ['Citron', 'fdf369'],
  ['Black/silver Seam', 'C0C0C0'],
  ['Black/gold Seam', 'FFD700'],
  ['Rust', 'b5433f'],
  ['Black/grey', '202b2c'],
  ['Black/redwood', 'a45a52 '],
  ['Black/green', '6bc375'],
  ['Zebra Print', '7b7770'],
  ['Reptile Print', '646461'],
  ['Citron Yellow', 'C59C6D'],
  ['Glossy Pink', 'f53e95'],
  ['Coral', 'd54d4b'],
  ['Jeans', '4a588a'],
  ['Military', '798268'],
  ['Marine', '1e2944'],
  ['Ocean Blue', '6591c4'],
  ['Dore Dark', '8d3d07 '],
  ['Street Grey', '7b756b '],
  ['Sun', 'f9d71c '],
  ['Singapour Anthracite', '383E42'],
  ['Moka', '3b2a24'],
  ['Black Melange', '1f1f1f'],
  ['Suntouch', 'a8856f'],
  ['Black Pantyhose/tights', '000000'],
  ['Sun Pantyhose / Tights', 'f9d71c'],
  ['Sable Pantyhose / Tights', '75553F'],
  ['Sable', '75553F'],
  ['Orange/brown', '89311d'],
  ['Olive/military', '474332'],
  ['Skin Tone', 'bf944a'],
  ['Black/white', '000000'],
  ['Milk', 'f5f4ed'],
  ['Military', 'C59C6D'],
  ['Amarena', 'b4113f'],
  ['Amarillo', '800020'],
  ['Antricite', '383E42'],
  ['Arancio', 'd83600'],
  ['Arancio Orange', 'd83600'],
  ['Asfalto', '2c3640'],
  ['Azzurro', '0087b0'],
  ['Bianco', 'eeead7'],
  ['Bianco Lana', 'f5f0d9'],
  ['Blu', '0a0b3b'],
  ['Bosco', '13232e'],
  ['Bouganvillea', 'e65984'],
  ['Bruciato', '763a25'],
  ['Caucciu', '944824'],
  ['Cobalto', '0060af'],
  ['Ciciamino', 'be2f7f'],
  ['Cina', '00529f'],
  ['Corda', 'e2dac4'],
  ['Giallo', 'ffcd01'],
  ['Indaco', '29214f'],
  ['Indigo', '212e67'],
  ['Lemon', 'ffff8b'],
  ['Lilla', 'b094c4'],
  ['Magneta', '6b1e45'],
  ['Melanzana', '402d33'],
  ['Marrone', '382d1e'],
  ['Marron Glace', '704A37'],
  ['Metal', '5d6165'],
  ['Militaire', '42512a'],
  ['Noisette', '64594b'],
  ['Olio', 'E1AD01 '],
  ['Ollo', 'E1AD01 '],
  ['Ottanio', '006084'],
  ['Paprika', 'd2501a'],
  ['Pavone', '009199'],
  ['Petrolio', '004935'],
  ['Pistacchio', '96bf0d'],
  ['Porpora', '421f76'],
  ['Prugna', '432f48'],
  ['Rio Verde', '01311f'],
  ['Rosa Antico', 'c37077'],
  ['Rosso', 'cc0622'],
  ['Rubino', '962038'],
  ['Salvia', '183c24'],
  ['Senape', 'c39402'],
  ['Verde Acqua', '00a3a3'],
  ['Verde Oliva', 'b5b35c'],
  ['Vinaccia', '6c273a'],
  ['Viola', '452c7f'],
  ['Zaffiro', '3c405e'],
  ['Grey Melange', '808080 '],
  ['Flower Purple', '8f00ff'],
  ['Damask Blue', '1D4B67'],
  ['Cosmetic', 'ba9d8b'],
  ['Ocean Blue Striped', '6590c5'],
  ['Safari', 'e8d5cc'],
  ['Black And Nude', '000000'],
  ['Mineral', 'cddee4'],
  ['Neutre', 'b7a088'],
  ['Plombe', '8e8f98'],
  ['Mineral 1', 'cddfe2'],
  ['Black Bordeaux', '862834'],
  ['Black Blue', '373b47'],
  ['Black Olive', '808000'],
  ['Green Leaves', '2D5A27'],
  ['Lilac', 'C8A2C8'],
  ['Purple Flowers', '8F00FF'],
  ['Black / Autumn Tones', 'd39238'],
  ['Military Green', '798268'],
  ['Petrol', '005f6a'],
  ['Chocolate', '7B3F00'],
  ['Olive', '808000'],
  ['Khaki', 'F0E68C'],
  ['Sand', 'C2B280'],
  ['Cioccolato', '403224'],
  ['Panna', 'efe7ce'],
  ['Naturale', '9c8166'],
  ['Bordo', '580f1c'],
  ['Ebano', '24282e'],
  ['Cammello', '947d45'],
  ['Bianco Seta', 'f4f1e7'],
  ['Flume Blete', 'D2D2CF'],
  ['Porto', 'D60019 '],
  ['Grey Shades', '6a7578'],
  ['Browny / Burgandy Shades Amazing', '966563'],
  ['Bluey Shades', '3c5362'],
  ['Castagna', 'b37a25'],
  ['Maronne', '60341c '],
  ['Playa', 'e3c3a9'],
  ['Ribes', '5d3450'],
  ['Fume Blete', '757a80'],
  ['Cosmetic T', 'be9d8f'],
  ['Cosmetic B', '373a4e'],
  ['Cosmetic A', 'ba4d56'],
  ['Nero A', 'ba4d56'],
  ['Nero T', '373a4e'],
  ['Corallo', 'e9cdb7'],
  ['Grigio Perla', 'e9e5e1'],
  ['Nero Melange', '000000'],
  ['Grigio Perla Pantyhose / Tights', 'e9e5e1'],
  ['Militare', '798268'],
  ['Coca Cola', 'fe001a'],
  ['Grigio Medio', '9b9793'],
  ['Fango', '5c5f56'],
  ['Nero Black', '000000'],
  ['Rosa', 'cc0622'],
  ['Menta', '86cac1'],
  ['Cielo', '8dd0e9'],
  ['Lampone', 'e3006d'],
  ['Cappucino', '7D584D'],
  ['Bianca', 'ffffff'],
  ['Ciello', '8dd0e9'],
  ['Seta T', '000000'],
  ['Noce', 'D2B48C'],
  ['Zucchero', '1a6271'],
  ['Blue Jeans', '0a0b3b'],
  ['Melon', 'FDBCB4'],
  ['Black And Sparkles Tights', '000000'],
  ['Petrollo', '1d3629'],
  ['Cosmetic Var A', 'ba4d56'],
  ['Nero Var A', 'ba4d56'],
  ['Caresse', 'c69264'],
  ['Black / Green', '006400'],
  ['Bluette', '9EC2D8'],
  ['Rooibos', 'A23C26'],
  ['Eden', '264e36'],
  ['Sughero', '8F3511'],
  ['Stormy', '5a6caa'],
  ['Rosso/ Red', 'cc0622'],
  ['Fumo/grey', '5D3630'],
  ['Noisette/light Brownish', '64594b'],
  ['Asfalto/ Dark Grey', '2c3640'],
  ['Castagna/Brownish', 'b37a25'],
  ['Ciclamino', 'e447ab'],
  ['Pine', '2a2f23'],
  ['Heathered Grey', '9AA297'],
  ['Ocra', 'f8e2a4'],
  ['Girl', 'f4cfd7'],
  ['Mare', '0060af'],
  ['Sabbia', 'c69264'],
  ['Coca Cola Brown', 'fe001a']
];



function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

function hex_lookup(brand, string){
  string = toTitleCase(string);
  string = string.replace(/'/g, '');
  string = string.replace(' Melange', '');
  
  for (let i = 0; i < colours.length; i++) {
	if(colours[i][0] == string){
		return "#" + colours[i][1];
	}
  }
	
}

function color_swatch(brand) {
  var color_name_elements = document.querySelectorAll(".grid-product__colors a.color-swatch span");
  var color_name = [];
  var color_hex = [];
  
  for (let i = 0; i < color_name_elements.length; i++) {
    var innerText = color_name_elements[i].innerText;
    var textSplit = innerText.split(" (");
    var textSplit2 = textSplit[0].split(" &");
    
    color_name.push(innerText);
    var hex = hex_lookup(brand, textSplit2[0]);
    color_hex.push(hex);
  }
  
  
  for (let i = 0; i < color_name.length; i++) {
    color_name[i] = color_name[i].replace('(', '');
    color_name[i] = color_name[i].replace(')', '');
color_name[i] = color_name[i].replace(/'/g, '')
    color_name[i] = color_name[i].replace(/[.,\/#!$%\^&\*;:{}=\-_`'~()]/g, ' ');
    /*/[.,\/#!$%\^&\*;:{}=\-_`~()]/g*/
    color_name[i] = color_name[i].replace(/ /g, "-");
    color_name[i] = color_name[i].replace(/-+/g,'-');
    color_name[i] = color_name[i].toLowerCase();
    
    var arg = ".grid-product__colors a.color-swatch--" + color_name[i];
    console.log(arg);
    console.log(color_hex[i]);
    var allElements = document.querySelectorAll(arg);
    
    for(let c = 0; c < allElements.length; c++){
      allElements[c].style = "background-color: " + color_hex[i];
    }
  }
}